import { isNil, isEmpty } from 'lodash'
import { Status } from '@taxfyle/api-internal/internal/job_pb'

/**
 * Job Status Filter.
 */
export enum JobStatusFilterOption {
  /**
   * Jobs in onboarding.
   */
  Onboarding,
  /**
   * Jobs in info gathering.
   */
  InfoGathering,
  /**
   * Jobs unclaimed.
   */
  Unclaimed,
  /**
   * Jobs in progress.
   */
  InProgress,
  /**
   * Current jobs.
   */
  Current,
  /**
   * Jobs on hold.
   */
  OnHold,
  /**
   * Idle jobs.
   */
  Idle,
  /**
   * Closed jobs.
   */
  Closed,
}

/**
 * Checks whether the status matches the status filters.
 *
 * @param status
 * @param statusFilters
 */
export function matchesStatusFilter(
  status: Status,
  statusFilters?: JobStatusFilterOption[],
) {
  if (isNil(statusFilters) || isEmpty(statusFilters)) {
    return true
  }

  return statusFilters.some((filter) => isStatusMatch(status, filter))
}

function isStatusMatch(
  status: Status,
  statusFilter: JobStatusFilterOption,
): boolean {
  switch (statusFilter) {
    case JobStatusFilterOption.Current:
      return (
        status === Status.CLAIMED ||
        status === Status.UNCLAIMED ||
        status === Status.UNDER_CONSTRUCTION
      )
    case JobStatusFilterOption.InfoGathering:
      return status === Status.INFO_GATHERING
    case JobStatusFilterOption.OnHold:
      return status === Status.ON_HOLD
    case JobStatusFilterOption.Idle:
      return status === Status.IDLE
    case JobStatusFilterOption.Closed:
      return status === Status.CLOSED
    case JobStatusFilterOption.InProgress:
      return status === Status.CLAIMED
    case JobStatusFilterOption.Unclaimed:
      return status === Status.UNCLAIMED
    case JobStatusFilterOption.Onboarding:
      return status === Status.UNDER_CONSTRUCTION
    default:
      return false
  }
}
